/* Theme behaviour: mobile menu, bundle picker, add-to-cart with add-ons,
   gallery thumbs, sticky add-to-cart bar, toast. No dependencies. */
(function () {
  'use strict';

  // In the static preview there is no Shopify backend.
  var isPreview = !window.Shopify || location.protocol === 'file:';

  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var nav = document.getElementById(button.getAttribute('aria-controls'));
      var open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open);
    });
  });

  /* ---------- Product forms ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var idInput = form.querySelector('[data-variant-input]');
    var buttonPrice = form.querySelector('[data-button-price]');
    var submit = form.querySelector('[type="submit"]');
    var error = form.querySelector('.product-form__error');
    var qtyInput = form.querySelector('[data-quantity-input]');
    var updateUrl = form.dataset.updateUrl === 'true';
    var quantityMode = form.dataset.mode === 'quantity';
    var discount = Number(form.dataset.discount) || 0;      // cents off each item
    var discountMin = Number(form.dataset.discountMin) || 0; // items needed for it
    var maxQty = Number(form.dataset.max) || 10;
    var plural = form.dataset.unitPlural || 'items';
    var moneyFormat = form.dataset.moneyFormat || '${{amount}}';
    var options = Array.prototype.slice.call(form.querySelectorAll('[data-option]'));

    function money(cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var type = match ? match[1] : 'amount';
      var decimals = type.indexOf('no_decimals') === -1 ? 2 : 0;
      var parts = (cents / 100).toFixed(decimals).split('.');
      var comma = type.indexOf('comma_separator') !== -1;
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      var value = parts[1] ? whole + (comma ? ',' : '.') + parts[1] : whole;
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    // Prices for one option at a quantity. Savings are rounded to whole dollars.
    function pricesFor(option, qty) {
      var units = Number(option.dataset.units) * qty;
      var each = Number(option.dataset.each);
      if (quantityMode && discount && units >= discountMin) each -= discount;
      var now = each * units;
      var was = Number(option.dataset.compare) * units;
      return { units: units, each: each, now: now, was: was, save: Math.round((was - now) / 100) * 100 };
    }

    function render(option, qty) {
      var p = pricesFor(option, qty);
      option.querySelector('[data-now]').textContent = money(p.now);
      var was = option.querySelector('[data-was]');
      was.textContent = money(p.was);
      was.hidden = !(p.was > p.now);
      var save = option.querySelector('[data-save]');
      save.textContent = 'Save ' + money(p.save).replace(/[.,]00(?=\D*$)/, '');
      save.hidden = !(p.save > 0);
      option.querySelector('[data-qty-value]').textContent = qty;
      option.querySelector('[data-qty-minus]').disabled = qty <= 1;
      option.querySelector('[data-qty-plus]').disabled = qty >= maxQty;
      option.querySelector('[data-qty-total]').textContent =
        quantityMode && p.units > 1 ? p.units + ' ' + plural + ' total' : '';
      if (quantityMode) {
        var sub = option.querySelector('[data-sub]');
        if (sub.dataset.original === undefined) sub.dataset.original = sub.textContent;
        sub.textContent = p.units > 1 ? money(p.each) + ' each' : sub.dataset.original;
      }
      option._qty = qty;
      return p;
    }

    function update() {
      var option = options.filter(function (o) { return o.classList.contains('is-selected'); })[0];
      if (!option) return;
      var p = render(option, option._qty || 1);
      idInput.value = option.dataset.variant;
      qtyInput.value = p.units;
      if (buttonPrice) buttonPrice.textContent = money(p.now);
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
        el.textContent = money(p.now);
      });
    }

    function selectOption(radio) {
      options.forEach(function (option) {
        option.classList.toggle('is-selected', option.contains(radio));
        render(option, 1); // switching option resets every stepper to 1
      });
      update();
      if (updateUrl && !isPreview && !quantityMode) {
        var url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState({}, '', url);
      }
    }

    options.forEach(function (option) {
      option.querySelector('input[type="radio"]').addEventListener('change', function (event) {
        selectOption(event.target);
      });
      [['[data-qty-minus]', -1], ['[data-qty-plus]', 1]].forEach(function (pair) {
        option.querySelector(pair[0]).addEventListener('click', function (event) {
          event.preventDefault();
          var qty = Math.min(maxQty, Math.max(1, (option._qty || 1) + pair[1]));
          option._qty = qty;
          update();
        });
      });
    });
    update();

    form.addEventListener('submit', function (event) {
      var addons = Array.prototype.map.call(
        form.querySelectorAll('[data-addon]:checked'),
        function (input) { return { id: Number(input.value), quantity: 1 }; }
      );

      event.preventDefault();
      if (isPreview) {
        var count = Number(qtyInput.value) + addons.length;
        toast('Preview: ' + count + ' item' + (count > 1 ? 's' : '') + ' would be added to the cart.');
        return;
      }

      var items = [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }].concat(addons);
      submit.disabled = true;
      if (error) error.textContent = '';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            window.location.href = window.Shopify.routes.root + 'cart';
          });
        })
        .catch(function (err) {
          submit.disabled = false;
          if (error) error.textContent = err.message;
          else toast(err.message);
        });
    });
  });

  /* ---------- Quick add on product cards (single-variant add) ---------- */
  document.querySelectorAll('[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!isPreview) return; // real stores post the form normally
      event.preventDefault();
      toast('Preview: this item would be added to the cart.');
    });
  });

  /* ---------- Gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var img = main.querySelector('img');
        if (src && img) {
          img.src = src;
          img.removeAttribute('srcset');
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('[data-product-form][data-main="true"]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    var target = mainForm.querySelector('[type="submit"]');
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Show once the real button has scrolled above the viewport.
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(target);
    sticky.querySelector('button').addEventListener('click', function () {
      mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Newsletter in preview ---------- */
  if (isPreview) {
    document.querySelectorAll('.newsletter__form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        toast('Preview: email would be added to your Shopify customer list.');
      });
    });
  }
})();
